<div class="occasion-cells-item">
  <div class="occasion-cells-item-event" *ngIf="occasionData!.type === 'Event'">
    <div (click)="openBottomSheet(occasionData!)">
      <app-icon-text-date-cell
        [title]="occasionData!.title"
        [description]="occasionData!.description"
        [dateStr]="occasionData!.startDate | date : 'dd/MM'"
        [dateEnd]="occasionData!.endDate | date : 'dd/MM'"
        [hourRangeStr]="occasionData!.startDate | date : 'HH:mm'"
        [hourRangeEndStr]="occasionData!.endDate | date : 'HH:mm'"
        [scheduled]="showScheduled(occasionData!.releaseDate)"
        (clickToEdit)="updatePage($event, occasionData!)"
        [type]="occasionData!.type"
      >
      </app-icon-text-date-cell>
    </div>
    <div class="separation-line"></div>
    <div class="show-users-viewed-container">
      <div class="click-show-users-viewed-container">
        <div (click)="showUsersViewed()" class="click-show-users-viewed">
          <div
            class="click-arrow-user-list"
            [ngClass]="openUserViewed ? 'oppened' : 'closed'"
          ></div>
          <div class="phrase">Responsáveis que visualizaram</div>
        </div>
      </div>
      <div *ngIf="openUserViewed && !loading">
        <app-progress-sum-list-object
          [sumtext]="'Responsáveis'"
          [textlist]="'Vistos por'"
          [idOccasion]="occasionData!.id"
          [typeOccasion]="typeOccasion"
        >
        </app-progress-sum-list-object>
      </div>
    </div>
  </div>
  <div class="occasion-cells-item-news" *ngIf="occasionData!.type === 'News'">
    <app-icon-text-date-cell
      [title]="occasionData!.title"
      [description]="occasionData!.description | stripHtml"
      [dateStr]="occasionData!.startDate | date : 'dd/MM'"
      [dateEnd]="occasionData!.endDate | date : 'dd/MM'"
      [hourRangeStr]="occasionData!.startDate | date : 'HH:mm'"
      [hourRangeEndStr]="occasionData!.endDate | date : 'HH:mm'"
      [scheduled]="showScheduled(occasionData!.releaseDate)"
      (action)="onSelect($event, occasionData!)"
      [type]="occasionData!.type"
      [editRoute]="editRoute"
      [detailsRoute]="detailsRoute"
    >
    </app-icon-text-date-cell>
  </div>
</div>
